import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import "./index.css";
import "./App.css";
import "./styles.css";
import Register from './Register';
import Login from './Login'; 
import Borrow from './Borrow';
import BorrowHistory from './BorrowHistory'; // Import the BorrowHistory component
import Background from './Background';
import './common.css'; // Import the common CSS file
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import MachineStatus from './MachineStatus';
import { Typography, Button } from 'antd';
import Return from './Return';
const { Title } = Typography;

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <>
            <Background />
            <div className="outer-container">
              <div className="content-container-app">
              <Title level={1} style={{ fontFamily: 'Normal', fontSize: '2.5rem', fontWeight: 'bold', textAlign: 'center' , marginBottom:"0rem"}}>臺大循環餐盒系統試辦計畫</Title>
              <p style={{ fontFamily: 'Normal', fontSize: '2rem', fontWeight: 'bold', textAlign: 'center', marginTop: '0rem' }}>NTU ECOntainer Pilot Program</p>
                <img src="/eco-packaging.png" alt="Logo"  style={{ width: '25%'}} />
                <div className="button-container">
                  <Button type="primary" block className="button" href="/register">Register</Button>
                  <Button type="primary" block className="button" href="/login">Login</Button>
                </div>
              </div>
            </div>
          </>
        } />
        <Route path="/register" element={<><Background/><Register /></>} />
        <Route path="/login" element={<><Background/><Login /></>} />
        <Route path="/forgot-password" element={<><Background/><ForgotPassword /></>} />
        <Route path="/borrow" element={<><Background/><Borrow /></>} />
        <Route path="/borrow-history" element={<><Background /><BorrowHistory /></>} />
        <Route path="/reset-password" element={<><Background/><ResetPassword /></>} />
        <Route path="/machine-status" element={<><Background/><MachineStatus /></>} />
        <Route path="/xincule" element={<Return />} />
      </Routes>
    </Router>
  );
}

export default App;